import React from 'react';
import { ShieldIcon, MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="py-16 px-4 sm:px-6 lg:px-8 bg-[#F3EFE6] border-t border-[#EAE5DC]" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center" data-id="element-64">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm mb-6" data-id="element-65">
          <ShieldIcon className="w-8 h-8 text-[#5BB4A0]" data-id="element-66" />
        </div>

        <h3 className="text-2xl font-bold mb-4 text-[#1A1A1A]" data-id="element-67">
          🛡️ TOOLS UNIVERSO™
        </h3>

        <p className="text-lg text-[#1A1A1A] font-medium mb-3" data-id="element-68">
          El sistema de protección fiscal N°1 para Monotributistas y
          Trabajadores Independientes de Argentina — Edición 2026
        </p>

        <p className="text-[#6B7280] mb-8 italic" data-id="element-69">
          Porque proteger lo que ganaste no debería costarte el sueño.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-70">
          <a href="mailto:tools.universo@gmail.com" className="flex items-center gap-2 text-[#5BB4A0] hover:text-[#4A9382] font-medium transition-colors" data-id="element-71">
            <MailIcon className="w-4 h-4" data-id="element-72" />
            <span data-id="element-73">tools.universo@gmail.com</span>
          </a>
          <a href="https://www.toolsuniverso.shop" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#5BB4A0] hover:text-[#4A9382] font-medium transition-colors" data-id="element-74">
            <GlobeIcon className="w-4 h-4" data-id="element-75" />
            <span data-id="element-76">www.toolsuniverso.shop</span>
          </a>
        </div>

        <div className="border-t border-[#EAE5DC] pt-6" data-id="element-77">
          <p className="text-sm text-[#6B7280] mb-4" data-id="element-78">
            © Tools Universo™ 2026 — Todos los derechos reservados
          </p>
          <p className="text-[#6B7280] italic" data-id="element-79">
            🛡️ "En un país que cambia las reglas cada mañana, el que no tiene un
            plan, ya perdió."
          </p>
        </div>
      </div>
    </footer>;
}